import React, { useEffect, useMemo } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import DataReactTable from "../DataTable/components/DataReactTable";
import {
  fetchData,
  updateInitialData,
  updateStart,
} from "../../features/filter/filterSlice";
import VehicleComponent from "../../shared/components/table/components/VehicleComponent";
import {
  initialRangeData,
  initialContainsData,
} from "../../shared/constants/filterData";

import {
  AddFormButton,
  ColumnHeading,
  FilterButton,
  StatusContainer,
} from "../../shared/components/TableElements";
import getUnixTime from "date-fns/getUnixTime";
import { useState } from "react";
import {
  daysHoursMinutes,
  formatNumber,
  getDisplayDateWithTime,
  getDisplayDateWithTimeNew,
  getDistanceUnit,
} from "../../shared/helpers";
import { NATEXT } from "../../shared/constants";
import { useAuth } from "../../contexts/AuthContext";
import { useHistory, useLocation } from "react-router";
import { putApi } from "../../api/getUser";
import { updateUserSettingsData } from "../../features/columns/columnsSlice";
import ExplorePopup from "../../shared/components/ExplorePopup";
import { clearAllAdvancedFilters } from "../../features/advancedFilter/advancedFilterSlice";
import { LinkSpan } from "../../shared/components/form/FormElements";
import SubscribePopup from "../../shared/components/SubscribePopup";
import useFetchData from "../../shared/custom-hooks/useFetchData";
import getDefaultFilterData from "../../shared/constants/getDefaultFilterData";

const TripsTable = () => {
  const { t } = useTranslation("common");
  const history = useHistory();
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const columnWidth = 130;
  const { rowData, values, status } = useSelector((state) => state.filter);
  const filterData = useSelector((state) => state.filter.data);
  const {
    draw,
    length,
    search,
    order,
    start_date,
    end_date,
    start,
    filter_group_id,
    filter_vehicle_id,
    querystring,
  } = filterData;
  const columns = useSelector((state) => state.advancedFilter.trips);
  const { reload, setReload, isLoggedIn, setLoading, tag, isViewOnly } =
    useAuth();
  const newData = {
    ...filterData,
    ...columns,
    //querystring: "getalltrips",
  };
  const { minDate } = useSelector((state) => state.columns);
  const { orgDate } = useSelector((state) => state.user);

  const { distance, currency } = useSelector((state) => state.units);

  const users = useSelector((state) => state.users.list);

  const location = useLocation();
  //const fromCancel = location.state?.fromCancel;

  const valuesArray = [
    {
      id: 0,
      name: t("trip_distance"),
      value: values.footertotaldistance
        ? `${formatNumber(values.footertotaldistance, 2)} ${getDistanceUnit(
          distance
        )}`
        : NATEXT,
      //units: values.footertotaldistance ? "Km" : "",
      //icon: "currency",
    },
    {
      id: 1,
      name: t("trip_duration"),
      value: values.footertotaltime
        ? daysHoursMinutes(values.footertotaltime).display
        : NATEXT,
    },
    {
      id: 2,
      name: t("fillup_cost"),
      value: values.footertotalfillupcost
        ? `${formatNumber(values.footertotalfillupcost, 2)} ${currency}`
        : NATEXT,
    },
    {
      id: 3,
      name: t("expense_cost"),
      value: values.footertotalexpense
        ? `${formatNumber(values.footertotalexpense, 2)} ${currency}`
        : NATEXT,
    },
    {
      id: 4,
      name: t("trip_income"),
      value: values.footertotalincome
        ? `${formatNumber(values.footertotalincome, 2)} ${currency}`
        : NATEXT,
    },
  ];

  //Logic for first time load(Reload start_date and end_date)
  const [firstTimeLoad, setFirstTimeLoad] = useState(true);

  const [showExplorePopup, setShowExplorePopup] = useState(false);
  //State to show subscribe popup
  const [showSubscribePopup, setShowSubscribePopup] = useState(false);

  useFetchData({
    startDate: 0,
    endDate: getUnixTime(new Date()),
    query: "get_all_trips_data", //"getalltrips",
    sortIndex: 2,
  });

  //Data for Filters
  const filterToggleColumns = {
    depDate: false,
    depOdo: false,
    departure: false,
    arrDate: false,
    arrOdo: false,
    arrival: false,
    distance: false,
    time: false,
    tripBy: false,
    comments: false,
  };

  const { defaultContainsData, defaultRangeData } = getDefaultFilterData();

  const initialData = useMemo(
    () => ({
      date: {
        column: "date",
        name: t("date_tv"),
        dateOption: "all_time",
        from: new Date(minDate * 1000),
        to: new Date(),
        isFiltered: false,
      },
      // depDate: {
      //   column: "depDate",
      //   name: "Dep. Date",
      //   ...initialDateData,
      // },
      depOdo: {
        column: "depOdo",
        name: t("dep_odo"),
        ...defaultRangeData,
      },
      departure: {
        column: "departure",
        name: t("departure"),
        ...defaultContainsData,
      },
      // arrDate: {
      //   column: "arrDate",
      //   name: "Arr. Date",
      //   ...initialDateData,
      // },
      arrOdo: {
        column: "arrOdo",
        name: t("arr_odo"),
        ...defaultRangeData,
      },
      arrival: {
        column: "arrival",
        name: t("arrival"),
        ...defaultContainsData,
      },
      distance: {
        column: "distance",
        name: t("distance"),
        ...defaultRangeData,
      },
      time: {
        column: "time",
        name: t("trip_duration"),
        ...defaultRangeData,
      },
      tripBy: {
        column: "tripBy",
        name: t("trip_by"),
        ...defaultContainsData,
      },
      comments: {
        column: "comments",
        name: t("notes_tv"),
        ...defaultContainsData,
      },
    }),
    [minDate]
  );

  //Columns
  const columnHeaders = useMemo(
    () => [
      {
        id: 1,
        Header: t("vehicle"),
        accessor: "name",
        // Footer: 'Middle age:',
        // disableGlobalFilter: false,
        width: 130,
        disableFilters: true,
        Cell: ({ row }) => (
          <VehicleComponent
            vehicleName={row.original.name}
            groupName={row.original.group_name}
            vehicleId={row.original.veh_id}
            vehicleImg={row.original.veh_img}
            orgId={row.original.org_id}
          />
        ),
      },
      {
        id: 2,
        Header: t("dep_date_and_time"),
        accessor: "dep_date",
        //disableFilters: true,
        width: columnWidth,
        disableCol: true,
        //minWidth: 50,
        Cell: ({ row }) => {
          const { dep_date, sched_dep_date, trip_status } = row.original;
          const value = trip_status == 1 ? sched_dep_date : dep_date;
          return value ? getDisplayDateWithTimeNew(value) : NATEXT;
        },
      },
      {
        id: 3,
        Header: t("dep_loc"),
        accessor: "dep_loc",
        //disableFilters: true,
        width: columnWidth,
        Cell: ({ row }) => {
          const { dep_loc, sched_dep_loc, trip_status } = row.original;
          const value = trip_status == 1 ? sched_dep_loc : dep_loc;
          return value || NATEXT;
        },
        // disableGlobalFilter: false,
      },
      {
        id: 4,
        Header: t("dep_odo"),
        accessor: "dep_odo",
        //disableFilters: true,
        width: columnWidth,
        Cell: ({ row }) =>
          +row.original.dep_odo
            ? `${formatNumber(row.original.dep_odo)} ${getDistanceUnit(
              row.original.odo_unit
            )}`
            : NATEXT,
        // disableGlobalFilter: false,
      },
      {
        id: 5,
        Header: t("arr_date_and_time"),
        accessor: "arr_date",
        //disableFilters: true,
        width: columnWidth,
        // disableGlobalFilter: false,
        Cell: ({ value }) =>
          value ? getDisplayDateWithTimeNew(value) : NATEXT,
      },

      {
        id: 6,
        Header: t("arr_loc"),
        accessor: "arr_loc",
        //disableFilters: true,
        width: columnWidth,
        Cell: ({ row }) => {
          const { arr_loc, sched_arr_loc, trip_status } = row.original;
          const value = trip_status == 1 ? sched_arr_loc : arr_loc;
          return value || NATEXT;
        },
        // disableGlobalFilter: false,
      },
      {
        id: 7,
        Header: t("arr_odo"),
        accessor: "arr_odo",
        // disableGlobalFilter: false,
        disableSortBy: false,
        //disableFilters: true,
        width: columnWidth,
        Cell: ({ row }) =>
          row.original.arr_odo
            ? `${formatNumber(row.original.arr_odo)} ${getDistanceUnit(
              row.original.odo_unit
            )}`
            : NATEXT,
      },
      {
        id: 8,
        Header: t("trip_distance"),
        accessor: "trip_distance",
        //disableFilters: true,
        width: columnWidth,
        Cell: ({ row }) =>
          row.original.trip_distance
            ? `${formatNumber(row.original.trip_distance)} ${getDistanceUnit(
              row.original.odo_unit
            )}`
            : NATEXT,
        // disableGlobalFilter: false,
      },
      {
        id: 9,
        Header: t("trip_duration"),
        accessor: "trip_time",
        //disableFilters: true,
        width: columnWidth,
        Cell: ({ value }) =>
          value ? daysHoursMinutes(value)?.display : NATEXT,
      },
      {
        id: 10,
        Header: t("trip_by"),
        accessor: "uname",
        //disableFilters: true,
        width: columnWidth,
        // Cell: ({ value }) =>
        //   value ? users.find((u) => u.user_id === value)?.name : NATEXT,
      },
      {
        id: 11,
        Header: t("fillup_cost"),
        accessor: "total_fillup_cost", //"trip_fillups_cost",
        //disableFilters: true,
        width: columnWidth,
        Cell: ({ value }) =>
          +value ? `${formatNumber(value, 2)} ${currency}` : NATEXT,
      },
      {
        id: 12,
        Header: t("expense_cost"),
        accessor: "total_expense_cost", //"trip_expenses_cost",
        //disableFilters: true,
        width: columnWidth,
        Cell: ({ value }) =>
          +value ? `${formatNumber(value, 2)} ${currency}` : NATEXT,
      },
      {
        id: 13,
        Header: t("income"),
        accessor: "total_income_cost", //"trip_income_cost",
        //disableFilters: true,
        width: columnWidth,
        Cell: ({ value }) =>
          +value ? `${formatNumber(value, 2)} ${currency}` : NATEXT,
      },
      {
        id: 14,
        Header: t("notes_tv"),
        accessor: "comments",
        //disableFilters: true,
        width: columnWidth,
        Cell: ({ row }) => {
          const { comments, sched_comments, trip_status } = row.original;
          const value = trip_status == 1 ? sched_comments : comments;
          return value || NATEXT;
        },
      },
      {
        id: 15,
        Header: t("status"),
        accessor: "trip_status",
        Cell: ({ value }) => <TripStatus status={value} />,
        disableSortBy: true,
        //disableFilters: true,
        //width: getColumnWidth("distance", "Distance"),
        // disableGlobalFilter: false,
      },
      // {
      //   id: 'edit',
      //   Header: "",
      //   accessor: "edit",
      //   accessorId: "edit",
      //   Cell: () => <RowOptions />,
      //   disableSortBy: true,
      // },
      // {
      //   id: 12,
      //   Header: "Group Name",
      //   accessor: "group_name",
      //   //disableFilters: true,
      //   width: columnWidth,
      // },
    ],
    [distance, rowData, currency]
  );

  let count = 0;
  let defaultColumns = {};
  columnHeaders.forEach((column) => {
    defaultColumns[count] = {
      accessor: column.accessor,
      header: column.Header,
    };
    count++;
  });

  const handleAddTrip = () => {
    // if (tag === "essential-user") {
    //   setShowSubscribePopup(true);
    //   return;
    // }
    history.push("trips/addnew");
  };

  const reactTableData = {
    tableHeaderData: columnHeaders,
    tableRowsData: rowData,
  };

  return (
    <>
      {showExplorePopup && (
        <ExplorePopup
          showPopup={showExplorePopup}
          setShowPopup={setShowExplorePopup}
          exploreLink={"https://embed.getsmartcue.com/IOI7KURH"}
        />
      )}
      {showSubscribePopup && (
        <SubscribePopup
          showPopup={showSubscribePopup}
          setShowPopup={setShowSubscribePopup}
          message={t("subscribe_to_advanced_msg")}
        />
      )}
      <Container>
        <Row className="mx-1 d-flex align-items-center justify-content-around">
          {/* <Col
          sm={10}
          //className="d-flex justify-content-start align-items-center"
        >
          <ColumnHeading>{t("trips")}</ColumnHeading>
        </Col> */}
          <Col className="d-flex align-items-center gap-2">
            <ColumnHeading>{t("trips")}</ColumnHeading>
            {/* <FilterButton onClick={() => setShowExplorePopup(true)}>
              <i
                className="fi fi-rr-globe"
                style={{ margin: "4px 4px 0 0" }}
              ></i>
              <span>{t("explore")}</span>
            </FilterButton> */}
            <LinkSpan
              onClick={() => setShowExplorePopup(true)}
              style={{ alignSelf: "end" }}
            >
              {t("explore")}
            </LinkSpan>
          </Col>

          <Col
            sm={2}
            className="d-flex justify-content-end align-items-center mb-1"
          >
            {/* <Link to={"/trips/addnew"}> */}
            {!isViewOnly && (
              <AddFormButton
                id="add-trip-button"
                type="button"
                onClick={handleAddTrip}
              >
                {t("add_trip")}
              </AddFormButton>
            )}
            {/* </Link> */}
          </Col>
        </Row>
        <Row>
          <DataReactTable
            reactTableData={reactTableData}
            valuesArray={valuesArray}
            filterToggleColumns={filterToggleColumns}
            initialData={initialData}
            defaultColumns={defaultColumns}
          />
        </Row>
      </Container>
    </>
  );
};

export default TripsTable;

export const TripStatus = ({ status }) => {
  const { t } = useTranslation("common");
  let issueData = { text: "", bg: "" };

  if (status == 1) {
    issueData.text = t("scheduled");
    issueData.bg = "#9FC5F8";
  } else if (status == 2) {
    issueData.text = t("in_progress");
    issueData.bg = "#FFE599";
  } else if (status == 3) {
    issueData.text = t("completed");
    issueData.bg = "#B6D7A8";
  }

  return (
    <StatusContainer background={issueData.bg}>
      <p>{issueData.text}</p>
    </StatusContainer>
  );
};
